interface PermissionComponentProps {
  children: React.ReactNode;
  hasPermission?: number;
}
const PermissionComponent = ({
  children,
  hasPermission,
}: PermissionComponentProps) => {
  if (hasPermission !== 1) {
    return <></>;
  }

  return <>{children}</>;
};

export default PermissionComponent;
